import CustomPlatform from "$src/core/utils/platform/platform";

/** Gap between pills: 8 on phone/TV, 24 on web (Figma). */
const SNAP_PICKER_SPACING_STEP = CustomPlatform.select({ web: 6, default: 2 });

/** Content inset of a pill row: mirrors the grid's page gutter so pills line up with the columns. */
export const SNAP_PICKER_INSET_STEP = CustomPlatform.select({
  web: 0,
  tv: 2,
  default: 4,
});

export default SNAP_PICKER_SPACING_STEP;
